import { Role } from '../enum'

export const isRoleGuard = (allowedRole: Role, currentRole: Role = Role.USER) => {
  const roles = Object.values(Role)
  const index = roles.findIndex((r) => r === allowedRole)
  const more = roles.slice(index).find((r) => currentRole === r)
  return !!more
}
